import { getConstant } from '../utils';

export const getReviews = getConstant('GET_REVIEWS');
export const getReview = getConstant('GET_REVIEW');
export const clearReview = getConstant('CLEAR_REVIEW');
export const addReview = getConstant('ADD_REVIEW');
export const updateReview = getConstant('UPDATE_REVIEW');
export const removeReview = getConstant('REMOVE_REVIEW');
export const getAverageRate = getConstant('GET_AVERAGE_RATE');
